import { ColTypeDef, ICellRendererParams } from "ag-grid-community";
import React from "react";

import { faEllipsis } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../../atoms/Icon";
import { DropDownMenu, type DropDownMenuProps } from "../../../molecules/DropDownMenu";

// Custom dropdown option cell renderer that passes cell renderer params to dropdown menu
export const DropdownOptionCellRenderer = <T = unknown,>(params: ICellRendererParams<T>) => {
	// Extract dropdown menu props from cellRendererParams
	const propsCallback = params.colDef?.cellRendererParams as (rowData: T) => Partial<DropDownMenuProps>;

	// Check if propsCallback is a function before calling it
	const props = typeof propsCallback === "function" ? propsCallback(params.data as T) : {};

	// Extract common props that might be passed through cellRendererParams
	const {
		options = [],
		onSelect,
		disabled = false,
		className,
		menuClassName,
		style,
		activeKey,
		closeOnSelect = true,
		minWidth,
		placement,
		bordered = false,
		testid,
	}: Partial<DropDownMenuProps> = props || {};

	return (
		<div className="flex size-full items-center justify-center [&>div]:flex">
			<DropDownMenu
				options={options}
				onSelect={onSelect}
				disabled={disabled}
				className={className}
				menuClassName={menuClassName}
				style={style}
				activeKey={activeKey}
				closeOnSelect={closeOnSelect}
				minWidth={minWidth}
				placement={placement}
				bordered={bordered}
				testid={testid}
			>
				<Icon icon={faEllipsis} size={24} color="neutral-5" />
			</DropDownMenu>
		</div>
	);
};

const DropdownOptionCol: ColTypeDef = {
	cellClass: "py-table-dropdown-cell",
	cellRenderer: DropdownOptionCellRenderer,
};

export default DropdownOptionCol;
